"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const list_1 = require("../list");
exports.emailTemplateBlockIs = (block, type, recurse, excludeLocked) => {
    var _a, _b, _c, _d, _e, _f, _g;
    let result = false;
    if (excludeLocked && block.lockable && block.locked) {
        return false;
    }
    switch (type) {
        case 'refreshable':
            result = !!(!block.locked &&
                block.contentItem &&
                block.contentFeed &&
                typeof block.contentSlotNumber === 'number');
            break;
        case 'contentField':
            result =
                block.type === 'field' &&
                    (block.fieldType === 'html' ||
                        block.fieldType === 'datetime' ||
                        block.fieldType === 'text' ||
                        block.fieldType === 'url');
            break;
        case 'clearable':
            result =
                !block.locked &&
                    (exports.emailTemplateBlockIs(block, 'userContent', recurse, excludeLocked) ||
                        exports.emailTemplateBlockIs(block, 'importedContent', recurse, excludeLocked));
            break;
        case 'anyContent':
            result =
                exports.emailTemplateBlockIs(block, 'userContent', recurse, excludeLocked) ||
                    exports.emailTemplateBlockIs(block, 'importedContent', recurse, excludeLocked);
            break;
        case 'highlighted':
            result = block.type === 'group';
            break;
        case 'userContent':
            result =
                block.contentStr &&
                    typeof block.contentStr === 'string' &&
                    block.contentStr.trim();
            break;
        case 'hidden':
            result = block.hidden || (block.hideable && block.hidden);
            break;
        case 'locked':
            result = block.locked || (block.lockable && block.locked);
            break;
        case 'conversions':
            result =
                ((_c = (_b = (_a = block) === null || _a === void 0 ? void 0 : _a.contentFeed) === null || _b === void 0 ? void 0 : _b.contentMapping) === null || _c === void 0 ? void 0 : _c.conversions) &&
                    ((_g = (_f = (_e = (_d = block) === null || _d === void 0 ? void 0 : _d.contentFeed) === null || _e === void 0 ? void 0 : _e.contentMapping) === null || _f === void 0 ? void 0 : _f.conversions) === null || _g === void 0 ? void 0 : _g.length) > 0;
            break;
        case 'importedContent':
            result = block.contentFeed && block.contentFieldKey && block.contentItem;
            break;
        default:
            throw new Error(`Invalid type: ${type}`);
    }
    result = !!result;
    if (recurse && block.childBlocks && block.childBlocks.length > 0) {
        return (result || list_1.emailTemplateBlocksAre(block.childBlocks || [], type, recurse));
    }
    return result;
};
//# sourceMappingURL=emailTemplateBlockIs.js.map